import styled from "styled-components";
import { DesignTokens } from "../../styles/design-tokens";
import { ErrorIcon } from "../icons/icons";

const { colors } = DesignTokens;

export const ErrorIndicator = styled(ErrorIcon)`
  color: ${colors.feedback.error};
`;
